import "../daterangepicker/jquery.daterangepicker.js";

export default function () {
    if ($('.daterange-picker').length > 0)
        $('.daterange-picker').dateRangePicker(
            {
                format: 'DD-MM-YYYY',
                separator: ' - ',
                minDays: 1,
                maxDays: 600,
                language: 'pl',
                autoClose: true,
                startOfWeek: 'monday',
                showShortcuts: true,
                customShortcuts:
                    [
                        {
                            name: 'ostatnie 7 dni',
                            dates: function () {
                                var start = moment().day(-7).toDate();
                                var end = moment().day(0).toDate();
                                return [start, end];
                            }
                        },
                        {
                            name: 'ostatnie 30 dni',
                            dates: function () {
                                var start = moment().day(-30).toDate();
                                var end = moment().day(0).toDate();
                                return [start, end];
                            }
                        }
                    ],

                getValue: function () {
                    if ($('#date1').val() && $('#date2').val())
                        return $('#date1').val() + ' - ' + $('#date2').val();
                    else
                        return '';
                },
                setValue: function (s, s1, s2) {
                    $('#date1').val(s1);
                    $('#date2').val(s2);

                }
            });

    if ($('.daterange-picker-time').length > 0)
        $('.daterange-picker-time').dateRangePicker(
            {
                format: 'DD-MM-YYYY HH:mm',
                separator: ' do ',
                minDays: 1,
                maxDays: 600,
                language: 'pl',
                autoClose: false,
                startOfWeek: 'monday',
                showShortcuts: false,
                time: {
                    enabled: true
                },
                getValue: function () {
                    if ($('#datetime1').val() && $('#datetime2').val())
                        return $('#datetime1').val() + ' do ' + $('#datetime2').val();
                    else
                        return '';
                },
                setValue: function (s, s1, s2) {

                    $('#datetime1').val(s1);
                    $('#datetime2').val(s2);

                }
            });

    $(".single-datepicker-time").each(function (i, obj) {
        $(obj).dateRangePicker(
            {
                format: "DD-MM-YYYY HH:mm",
                container: "body",
                autoClose: true,
                singleDate: true,
                showShortcuts: false,
                time: {
                    enabled: true
                }
            });
    });

    $(".single-datepicker").each(function (i, obj) {
        $(obj).dateRangePicker(
            {
                format: "DD-MM-YYYY",
                container: "body",
                autoClose: true,
                singleDate: true,
                showShortcuts: false
            });
    });
}